/* Synchronize native FAQ disclosure state without replacing keyboard/toggle behavior. */
(() => {
  const selector = '.avl-home-faq details, .avl-guide__questions details, details.avlpi-disclosure, details.avlpe-shelter-details, details.faq-item, details.adv-faq__item';
  const initialized = new WeakSet();
  let sequence = 0;

  const nextId = prefix => {
    let id;
    do { id = `${prefix}-${++sequence}`; } while (document.getElementById(id));
    return id;
  };

  const enhance = root => {
    const disclosures = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) disclosures.unshift(root);
    disclosures.forEach(details => {
      if (initialized.has(details)) return;
      const summary = details.querySelector(':scope > summary');
      const answer = summary?.nextElementSibling;
      if (!summary || !answer) return;

      summary.id ||= nextId('AvlFaqQuestion');
      answer.id ||= nextId('AvlFaqAnswer');
      summary.setAttribute('aria-controls', answer.id);
      answer.setAttribute('aria-labelledby', summary.id);
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      sync();
      details.addEventListener('toggle', sync);
      initialized.add(details);
    });
  };

  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
